export const sampledValues: any = {
  '-80323': {
    id: -80323,
    connector: '-2',
    timestamp: '2022-02-08T07:37:21.117000',
    value: '0',
    context: 'Transaction.End',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:37:22.637074',
    updated: '2022-02-08T07:37:22.637095',
    meter_value: 14080,
  },
  '-80321': {
    id: -80321,
    connector: '-2',
    timestamp: '2022-02-08T07:37:21.117000',
    value: '85204999',
    context: 'Transaction.End',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:37:22.617042',
    updated: '2022-02-08T07:37:22.617052',
    meter_value: 14080,
  },
  '-80325': {
    id: -80325,
    connector: '-2',
    timestamp: '2022-02-08T07:37:21.117000',
    value: '0',
    context: 'Transaction.End',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:37:22.653209',
    updated: '2022-02-08T07:37:22.653220',
    meter_value: 14080,
  },
  '-80324': {
    id: -80324,
    connector: '-2',
    timestamp: '2022-02-08T07:37:21.117000',
    value: '0',
    context: 'Transaction.End',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:37:22.645292',
    updated: '2022-02-08T07:37:22.645302',
    meter_value: 14080,
  },
  '-80326': {
    id: -80326,
    connector: '-2',
    timestamp: '2022-02-08T07:37:21.117000',
    value: '100.0',
    context: 'Transaction.End',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:37:22.660588',
    updated: '2022-02-08T07:37:22.660599',
    meter_value: 14080,
  },
  '-80322': {
    id: -80322,
    connector: '-2',
    timestamp: '2022-02-08T07:37:21.117000',
    value: '660',
    context: 'Transaction.End',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:37:22.628998',
    updated: '2022-02-08T07:37:22.629009',
    meter_value: 14080,
  },
  '-80317': {
    id: -80317,
    connector: '-2',
    timestamp: '2022-02-08T07:37:19.538000',
    value: '40',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:37:21.587335',
    updated: '2022-02-08T07:37:21.587346',
    meter_value: 14079,
  },
  '-80315': {
    id: -80315,
    connector: '-2',
    timestamp: '2022-02-08T07:37:19.538000',
    value: '85204925',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:37:21.561028',
    updated: '2022-02-08T07:37:21.561041',
    meter_value: 14079,
  },
  '-80319': {
    id: -80319,
    connector: '-2',
    timestamp: '2022-02-08T07:37:19.538000',
    value: '26400',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:37:21.603966',
    updated: '2022-02-08T07:37:21.603975',
    meter_value: 14079,
  },
  '-80318': {
    id: -80318,
    connector: '-2',
    timestamp: '2022-02-08T07:37:19.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:37:21.595821',
    updated: '2022-02-08T07:37:21.595832',
    meter_value: 14079,
  },
  '-80320': {
    id: -80320,
    connector: '-2',
    timestamp: '2022-02-08T07:37:19.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:37:21.611270',
    updated: '2022-02-08T07:37:21.611280',
    meter_value: 14079,
  },
  '-80316': {
    id: -80316,
    connector: '-2',
    timestamp: '2022-02-08T07:37:19.538000',
    value: '660',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:37:21.578290',
    updated: '2022-02-08T07:37:21.578301',
    meter_value: 14079,
  },
  '-80311': {
    id: -80311,
    connector: '-2',
    timestamp: '2022-02-08T07:36:49.540000',
    value: '39',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:36:51.497287',
    updated: '2022-02-08T07:36:51.497298',
    meter_value: 14078,
  },
  '-80309': {
    id: -80309,
    connector: '-2',
    timestamp: '2022-02-08T07:36:49.540000',
    value: '85204706',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:36:51.475679',
    updated: '2022-02-08T07:36:51.475690',
    meter_value: 14078,
  },
  '-80313': {
    id: -80313,
    connector: '-2',
    timestamp: '2022-02-08T07:36:49.540000',
    value: '25701',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:36:51.514496',
    updated: '2022-02-08T07:36:51.514508',
    meter_value: 14078,
  },
  '-80312': {
    id: -80312,
    connector: '-2',
    timestamp: '2022-02-08T07:36:49.540000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:36:51.506420',
    updated: '2022-02-08T07:36:51.506431',
    meter_value: 14078,
  },
  '-80314': {
    id: -80314,
    connector: '-2',
    timestamp: '2022-02-08T07:36:49.540000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:36:51.522796',
    updated: '2022-02-08T07:36:51.522807',
    meter_value: 14078,
  },
  '-80310': {
    id: -80310,
    connector: '-2',
    timestamp: '2022-02-08T07:36:49.540000',
    value: '659',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:36:51.489513',
    updated: '2022-02-08T07:36:51.489525',
    meter_value: 14078,
  },
  '-80305': {
    id: -80305,
    connector: '-2',
    timestamp: '2022-02-08T07:36:19.538000',
    value: '39',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:36:21.454375',
    updated: '2022-02-08T07:36:21.454385',
    meter_value: 14077,
  },
  '-80303': {
    id: -80303,
    connector: '-2',
    timestamp: '2022-02-08T07:36:19.538000',
    value: '85204486',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:36:21.431805',
    updated: '2022-02-08T07:36:21.431816',
    meter_value: 14077,
  },
  '-80307': {
    id: -80307,
    connector: '-2',
    timestamp: '2022-02-08T07:36:19.538000',
    value: '25662',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:36:21.469111',
    updated: '2022-02-08T07:36:21.469122',
    meter_value: 14077,
  },
  '-80306': {
    id: -80306,
    connector: '-2',
    timestamp: '2022-02-08T07:36:19.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:36:21.461907',
    updated: '2022-02-08T07:36:21.461918',
    meter_value: 14077,
  },
  '-80308': {
    id: -80308,
    connector: '-2',
    timestamp: '2022-02-08T07:36:19.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:36:21.476424',
    updated: '2022-02-08T07:36:21.476440',
    meter_value: 14077,
  },
  '-80304': {
    id: -80304,
    connector: '-2',
    timestamp: '2022-02-08T07:36:19.538000',
    value: '658',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:36:21.446233',
    updated: '2022-02-08T07:36:21.446244',
    meter_value: 14077,
  },
  '-80299': {
    id: -80299,
    connector: '-2',
    timestamp: '2022-02-08T07:35:49.539000',
    value: '40',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:35:51.487663',
    updated: '2022-02-08T07:35:51.487674',
    meter_value: 14076,
  },
  '-80297': {
    id: -80297,
    connector: '-2',
    timestamp: '2022-02-08T07:35:49.539000',
    value: '85204267',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:35:51.466201',
    updated: '2022-02-08T07:35:51.466213',
    meter_value: 14076,
  },
  '-80301': {
    id: -80301,
    connector: '-2',
    timestamp: '2022-02-08T07:35:49.539000',
    value: '26280',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:35:51.504359',
    updated: '2022-02-08T07:35:51.504371',
    meter_value: 14076,
  },
  '-80300': {
    id: -80300,
    connector: '-2',
    timestamp: '2022-02-08T07:35:49.539000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:35:51.495583',
    updated: '2022-02-08T07:35:51.495594',
    meter_value: 14076,
  },
  '-80302': {
    id: -80302,
    connector: '-2',
    timestamp: '2022-02-08T07:35:49.539000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:35:51.513713',
    updated: '2022-02-08T07:35:51.513725',
    meter_value: 14076,
  },
  '-80298': {
    id: -80298,
    connector: '-2',
    timestamp: '2022-02-08T07:35:49.539000',
    value: '657',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:35:51.480178',
    updated: '2022-02-08T07:35:51.480188',
    meter_value: 14076,
  },
  '-80293': {
    id: -80293,
    connector: '-2',
    timestamp: '2022-02-08T07:35:19.538000',
    value: '39',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:35:21.775673',
    updated: '2022-02-08T07:35:21.775684',
    meter_value: 14075,
  },
  '-80291': {
    id: -80291,
    connector: '-2',
    timestamp: '2022-02-08T07:35:19.538000',
    value: '85204049',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:35:21.752265',
    updated: '2022-02-08T07:35:21.752277',
    meter_value: 14075,
  },
  '-80295': {
    id: -80295,
    connector: '-2',
    timestamp: '2022-02-08T07:35:19.538000',
    value: '25584',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:35:21.792632',
    updated: '2022-02-08T07:35:21.792646',
    meter_value: 14075,
  },
  '-80294': {
    id: -80294,
    connector: '-2',
    timestamp: '2022-02-08T07:35:19.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:35:21.783590',
    updated: '2022-02-08T07:35:21.783602',
    meter_value: 14075,
  },
  '-80296': {
    id: -80296,
    connector: '-2',
    timestamp: '2022-02-08T07:35:19.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:35:21.802624',
    updated: '2022-02-08T07:35:21.802636',
    meter_value: 14075,
  },
  '-80292': {
    id: -80292,
    connector: '-2',
    timestamp: '2022-02-08T07:35:19.538000',
    value: '656',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:35:21.766822',
    updated: '2022-02-08T07:35:21.766833',
    meter_value: 14075,
  },
  '-80287': {
    id: -80287,
    connector: '-2',
    timestamp: '2022-02-08T07:34:49.538000',
    value: '39',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:34:51.504236',
    updated: '2022-02-08T07:34:51.504248',
    meter_value: 14074,
  },
  '-80285': {
    id: -80285,
    connector: '-2',
    timestamp: '2022-02-08T07:34:49.538000',
    value: '85203831',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:34:51.477537',
    updated: '2022-02-08T07:34:51.477549',
    meter_value: 14074,
  },
  '-80289': {
    id: -80289,
    connector: '-2',
    timestamp: '2022-02-08T07:34:49.538000',
    value: '25584',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:34:51.525767',
    updated: '2022-02-08T07:34:51.525781',
    meter_value: 14074,
  },
  '-80288': {
    id: -80288,
    connector: '-2',
    timestamp: '2022-02-08T07:34:49.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:34:51.514227',
    updated: '2022-02-08T07:34:51.514238',
    meter_value: 14074,
  },
  '-80290': {
    id: -80290,
    connector: '-2',
    timestamp: '2022-02-08T07:34:49.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:34:51.535828',
    updated: '2022-02-08T07:34:51.535841',
    meter_value: 14074,
  },
  '-80286': {
    id: -80286,
    connector: '-2',
    timestamp: '2022-02-08T07:34:49.538000',
    value: '656',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:34:51.494374',
    updated: '2022-02-08T07:34:51.494386',
    meter_value: 14074,
  },
  '-80281': {
    id: -80281,
    connector: '-2',
    timestamp: '2022-02-08T07:34:19.538000',
    value: '40',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:34:22.545401',
    updated: '2022-02-08T07:34:22.545412',
    meter_value: 14073,
  },
  '-80279': {
    id: -80279,
    connector: '-2',
    timestamp: '2022-02-08T07:34:19.538000',
    value: '85203596',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:34:22.523181',
    updated: '2022-02-08T07:34:22.523193',
    meter_value: 14073,
  },
  '-80283': {
    id: -80283,
    connector: '-2',
    timestamp: '2022-02-08T07:34:19.538000',
    value: '26280',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:34:22.561244',
    updated: '2022-02-08T07:34:22.561256',
    meter_value: 14073,
  },
  '-80282': {
    id: -80282,
    connector: '-2',
    timestamp: '2022-02-08T07:34:19.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:34:22.553395',
    updated: '2022-02-08T07:34:22.553406',
    meter_value: 14073,
  },
  '-80284': {
    id: -80284,
    connector: '-2',
    timestamp: '2022-02-08T07:34:19.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:34:22.568849',
    updated: '2022-02-08T07:34:22.568860',
    meter_value: 14073,
  },
  '-80280': {
    id: -80280,
    connector: '-2',
    timestamp: '2022-02-08T07:34:19.538000',
    value: '657',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:34:22.537393',
    updated: '2022-02-08T07:34:22.537405',
    meter_value: 14073,
  },
  '-80275': {
    id: -80275,
    connector: '-2',
    timestamp: '2022-02-08T07:33:49.538000',
    value: '49',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:33:51.460111',
    updated: '2022-02-08T07:33:51.460123',
    meter_value: 14072,
  },
  '-80273': {
    id: -80273,
    connector: '-2',
    timestamp: '2022-02-08T07:33:49.538000',
    value: '85203313',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:33:51.434542',
    updated: '2022-02-08T07:33:51.434554',
    meter_value: 14072,
  },
  '-80277': {
    id: -80277,
    connector: '-2',
    timestamp: '2022-02-08T07:33:49.538000',
    value: '32242',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:33:51.477181',
    updated: '2022-02-08T07:33:51.477193',
    meter_value: 14072,
  },
  '-80276': {
    id: -80276,
    connector: '-2',
    timestamp: '2022-02-08T07:33:49.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:33:51.468119',
    updated: '2022-02-08T07:33:51.468130',
    meter_value: 14072,
  },
  '-80278': {
    id: -80278,
    connector: '-2',
    timestamp: '2022-02-08T07:33:49.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:33:51.486832',
    updated: '2022-02-08T07:33:51.486844',
    meter_value: 14072,
  },
  '-80274': {
    id: -80274,
    connector: '-2',
    timestamp: '2022-02-08T07:33:49.538000',
    value: '658',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:33:51.451923',
    updated: '2022-02-08T07:33:51.451934',
    meter_value: 14072,
  },
  '-80269': {
    id: -80269,
    connector: '-2',
    timestamp: '2022-02-08T07:33:19.538000',
    value: '80',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:33:21.575027',
    updated: '2022-02-08T07:33:21.575037',
    meter_value: 14071,
  },
  '-80267': {
    id: -80267,
    connector: '-2',
    timestamp: '2022-02-08T07:33:19.538000',
    value: '85202882',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:33:21.552853',
    updated: '2022-02-08T07:33:21.552864',
    meter_value: 14071,
  },
  '-80271': {
    id: -80271,
    connector: '-2',
    timestamp: '2022-02-08T07:33:19.538000',
    value: '52800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:33:21.594909',
    updated: '2022-02-08T07:33:21.594926',
    meter_value: 14071,
  },
  '-80270': {
    id: -80270,
    connector: '-2',
    timestamp: '2022-02-08T07:33:19.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:33:21.583450',
    updated: '2022-02-08T07:33:21.583463',
    meter_value: 14071,
  },
  '-80272': {
    id: -80272,
    connector: '-2',
    timestamp: '2022-02-08T07:33:19.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:33:21.603797',
    updated: '2022-02-08T07:33:21.603808',
    meter_value: 14071,
  },
  '-80268': {
    id: -80268,
    connector: '-2',
    timestamp: '2022-02-08T07:33:19.538000',
    value: '660',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:33:21.566951',
    updated: '2022-02-08T07:33:21.566963',
    meter_value: 14071,
  },
  '-80263': {
    id: -80263,
    connector: '-2',
    timestamp: '2022-02-08T07:32:49.538000',
    value: '149',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:32:51.501428',
    updated: '2022-02-08T07:32:51.501439',
    meter_value: 14070,
  },
  '-80261': {
    id: -80261,
    connector: '-2',
    timestamp: '2022-02-08T07:32:49.538000',
    value: '85202195',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:32:51.475304',
    updated: '2022-02-08T07:32:51.475315',
    meter_value: 14070,
  },
  '-80265': {
    id: -80265,
    connector: '-2',
    timestamp: '2022-02-08T07:32:49.538000',
    value: '99383',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:32:51.517489',
    updated: '2022-02-08T07:32:51.517500',
    meter_value: 14070,
  },
  '-80264': {
    id: -80264,
    connector: '-2',
    timestamp: '2022-02-08T07:32:49.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:32:51.509589',
    updated: '2022-02-08T07:32:51.509600',
    meter_value: 14070,
  },
  '-80266': {
    id: -80266,
    connector: '-2',
    timestamp: '2022-02-08T07:32:49.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:32:51.525138',
    updated: '2022-02-08T07:32:51.525149',
    meter_value: 14070,
  },
  '-80262': {
    id: -80262,
    connector: '-2',
    timestamp: '2022-02-08T07:32:49.538000',
    value: '667',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:32:51.493432',
    updated: '2022-02-08T07:32:51.493442',
    meter_value: 14070,
  },
  '-80257': {
    id: -80257,
    connector: '-2',
    timestamp: '2022-02-08T07:32:19.538000',
    value: '195',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:32:22.098616',
    updated: '2022-02-08T07:32:22.098628',
    meter_value: 14069,
  },
  '-80255': {
    id: -80255,
    connector: '-2',
    timestamp: '2022-02-08T07:32:19.538000',
    value: '85201106',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:32:22.071962',
    updated: '2022-02-08T07:32:22.071973',
    meter_value: 14069,
  },
  '-80259': {
    id: -80259,
    connector: '-2',
    timestamp: '2022-02-08T07:32:19.538000',
    value: '129870',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:32:22.116501',
    updated: '2022-02-08T07:32:22.116513',
    meter_value: 14069,
  },
  '-80258': {
    id: -80258,
    connector: '-2',
    timestamp: '2022-02-08T07:32:19.538000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:32:22.107366',
    updated: '2022-02-08T07:32:22.107378',
    meter_value: 14069,
  },
  '-80260': {
    id: -80260,
    connector: '-2',
    timestamp: '2022-02-08T07:32:19.538000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:32:22.125028',
    updated: '2022-02-08T07:32:22.125040',
    meter_value: 14069,
  },
  '-80256': {
    id: -80256,
    connector: '-2',
    timestamp: '2022-02-08T07:32:19.538000',
    value: '666',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:32:22.088547',
    updated: '2022-02-08T07:32:22.088559',
    meter_value: 14069,
  },
  '-80251': {
    id: -80251,
    connector: '-2',
    timestamp: '2022-02-08T07:31:49.539000',
    value: '197',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:31:52.476988',
    updated: '2022-02-08T07:31:52.477001',
    meter_value: 14068,
  },
  '-80249': {
    id: -80249,
    connector: '-2',
    timestamp: '2022-02-08T07:31:49.539000',
    value: '85200017',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:31:52.451220',
    updated: '2022-02-08T07:31:52.451231',
    meter_value: 14068,
  },
  '-80253': {
    id: -80253,
    connector: '-2',
    timestamp: '2022-02-08T07:31:49.539000',
    value: '130217',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:31:52.496265',
    updated: '2022-02-08T07:31:52.496277',
    meter_value: 14068,
  },
  '-80252': {
    id: -80252,
    connector: '-2',
    timestamp: '2022-02-08T07:31:49.539000',
    value: '129800',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:31:52.486965',
    updated: '2022-02-08T07:31:52.486977',
    meter_value: 14068,
  },
  '-80254': {
    id: -80254,
    connector: '-2',
    timestamp: '2022-02-08T07:31:49.539000',
    value: '99.0',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:31:52.506118',
    updated: '2022-02-08T07:31:52.506131',
    meter_value: 14068,
  },
  '-80250': {
    id: -80250,
    connector: '-2',
    timestamp: '2022-02-08T07:31:49.539000',
    value: '661',
    context: 'Sample.Periodic',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:31:52.467190',
    updated: '2022-02-08T07:31:52.467203',
    meter_value: 14068,
  },
  '-80245': {
    id: -80245,
    connector: '-2',
    timestamp: '2022-02-08T07:31:19.434000',
    value: '0',
    context: 'Transaction.Begin',
    value_format: 'Raw',
    measurand: 'Current.Import',
    phase: null,
    location: 'Outlet',
    unit: 'A',
    created: '2022-02-08T07:31:23.038223',
    updated: '2022-02-08T07:31:23.038235',
    meter_value: 14067,
  },
  '-80243': {
    id: -80243,
    connector: '-2',
    timestamp: '2022-02-08T07:31:19.434000',
    value: '85199352',
    context: 'Transaction.Begin',
    value_format: 'Raw',
    measurand: 'Energy.Active.Import.Register',
    phase: null,
    location: 'Outlet',
    unit: 'Wh',
    created: '2022-02-08T07:31:23.008701',
    updated: '2022-02-08T07:31:23.008714',
    meter_value: 14067,
  },
  '-80247': {
    id: -80247,
    connector: '-2',
    timestamp: '2022-02-08T07:31:19.434000',
    value: '0',
    context: 'Transaction.Begin',
    value_format: 'Raw',
    measurand: 'Power.Active.Import',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:31:23.056051',
    updated: '2022-02-08T07:31:23.056063',
    meter_value: 14067,
  },
  '-80246': {
    id: -80246,
    connector: '-2',
    timestamp: '2022-02-08T07:31:19.434000',
    value: '129800',
    context: 'Transaction.Begin',
    value_format: 'Raw',
    measurand: 'Power.Offered',
    phase: null,
    location: 'Outlet',
    unit: 'W',
    created: '2022-02-08T07:31:23.047087',
    updated: '2022-02-08T07:31:23.047099',
    meter_value: 14067,
  },
  '-80248': {
    id: -80248,
    connector: '-2',
    timestamp: '2022-02-08T07:31:19.434000',
    value: '99.0',
    context: 'Transaction.Begin',
    value_format: 'Raw',
    measurand: 'SoC',
    phase: null,
    location: 'EV',
    unit: 'Percent',
    created: '2022-02-08T07:31:23.064919',
    updated: '2022-02-08T07:31:23.064931',
    meter_value: 14067,
  },
  '-80244': {
    id: -80244,
    connector: '-2',
    timestamp: '2022-02-08T07:31:19.434000',
    value: '0',
    context: 'Transaction.Begin',
    value_format: 'Raw',
    measurand: 'Voltage',
    phase: null,
    location: 'Outlet',
    unit: 'V',
    created: '2022-02-08T07:31:23.029502',
    updated: '2022-02-08T07:31:23.029514',
    meter_value: 14067,
  },
};
